import { CommonResponse, OcaenFreightRateRequest, OcaenFreightRateRequestDto, OcaenFreightRateResponseModel, OceanTotalAmountRequest } from "@gtpl/shared-models/masters";
import { connection } from "..";
import axios from "axios";

export class OcaenFreightRateService {
    activatedeActivate(data: OcaenFreightRateRequest) {
        throw new Error('Method not implemented.');
      }
      URL = connection.DEPLOY_URL + '/ocaen-freight-rates';
    
      async create(req:OcaenFreightRateRequestDto): Promise<OcaenFreightRateResponseModel> {
        return await axios.post(this.URL + '/create', req)
          .then(res => {
            return res.data
          })
      }
      async getAllOceanFreightRates(): Promise<OcaenFreightRateResponseModel> {
        return await axios.post(this.URL + '/getAllOcaenFreightRates')
          .then(res => {
            return res.data
          })
      }
      async getAllOcaenFreightRatesForInvoice(req:OceanTotalAmountRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllOcaenFreightRatesForInvoice',req)
          .then(res => {
            return res.data
          })
      }
}